export default __webpack_public_path__ + "static/media/regreenbus_info_bg_over.fb0eeb59.png";